<section>
  <kendo-grid [data]="surveyQuestionGridView"
              [height]="470"
              [sortable]="true"
              [navigable]="true"
              [filterable]="true"
              [groupable]="false"
              [reorderable]="true"
              [resizable]="false"
              [sort]="surveyGridstate.sort"
              (sortChange)="surveyGridSortChange($event)"
              [pageable]="{ buttonCount: 5, info: true }"
              [pageSize]="surveyGridstate.take"
              [skip]="surveyGridstate.skip"
              [columnMenu]="false"
              (pageChange)="surveyGridPageChange($event)"
              (dataStateChange)="surveyDataStateChange($event)"
              [filter]="surveyGridstate.filter"
              [loading]="surveyLoading">


    <kendo-grid-column field="languageCode" title="{{survey.languageLbl}}" [width]="120" [columnMenu]="false"
                       [filterable]="true" [editable]="false">
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
          <kendo-filter-contains-operator></kendo-filter-contains-operator>
        </kendo-grid-string-filter-cell>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="questions" title="{{survey.questionLbl}}" [columnMenu]="false"
                       [filterable]="true" [editable]="false">
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
          <kendo-filter-contains-operator></kendo-filter-contains-operator>
        </kendo-grid-string-filter-cell>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-command-column title="{{survey.isActive}}" [width]="135" field="isActive">
      <ng-template kendoGridCellTemplate let-dataItem>
        <kendo-switch [(ngModel)]="dataItem.isActive" [onLabel]="'Yes'"
                      [offLabel]="'No'" [disabled]="true">
        </kendo-switch>
      </ng-template>
    </kendo-grid-command-column>

    <kendo-grid-command-column title="{{survey.actionLbl}}" [width]="150" field="">
      <ng-template kendoGridCellTemplate let-dataItem>
        <button kendoButton class="m-2 clearKendoButton btn btn-success btnSizeCls"
                (click)="editSurveyDetails(dataItem)">
          <span class=" k-icon k-i-edit k-i-pencil"></span>
        </button>

        <button class="k-button k-grid-remove-command " (click)="removeConfirmation(dataItem)">
          <span class="k-icon k-i-trash">
          </span>
        </button>
      </ng-template>
    </kendo-grid-command-column>

    <ng-template kendoPagerTemplate let-totalPages="totalPages" let-currentPage="currentPage">
      <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
      <kendo-pager-numeric-buttons [buttonCount]="5"></kendo-pager-numeric-buttons>
      <kendo-pager-info></kendo-pager-info>
      <kendo-pager-next-buttons></kendo-pager-next-buttons>
      <kendo-pager-page-sizes [pageSizes]="[50,75,100]"></kendo-pager-page-sizes>
    </ng-template>
  </kendo-grid>
  <div class="col-sm-12 center">
    <button (click)="toggleSurveyDialog()" [icon]="'plus'" class="m-3 btn btn-success" kendoButton>
      {{survey.addSurveyQuestionLbl}}
    </button>&nbsp;

  </div>
</section>
<section class="dialogSection">
  <kendo-dialog title="Add Survey Question" *ngIf="surveyDialog.opened" (close)="toggleSurveyDialog()">
    <form [formGroup]="surveyForm">
      <div class="row">
        <input type="hidden" formControlName="surveyId" />
        <div class="col-sm-12">
          <div class="form-group">
            <label class="lbl">{{survey.languageLbl}}</label>
            <kendo-dropdownlist class="kendoInput" name="languageCode"
                                formControlName="languageCode"
                                [data]="getLanguages"
                                [ngModel]="{languageCode:selectedLanguage,languageCode:selectedLanguage}"
                                [textField]="'languageCode'"
                                [valueField]="'languageCode'"
                                [ngClass]="{'borderRed':survey.isEmptyLanguage && survey.isSubmitted}"
                                (blur)="validateForm()">
            </kendo-dropdownlist>
          </div>
          <div class="form-group">
            <label class="lblCls">
              {{survey.questionLbl}}
            </label>
            <textarea kendoTextArea class="kendoInput"
                      formControlName="question"
                      [ngClass]="{'borderRed':survey.isEmptyQuestions && survey.isSubmitted}"
                      (blur)="validateForm()"></textarea>
          </div>

          <div class="form-group">
            <label class="lblCls">
              {{survey.isActive}}
            </label>
            <kendo-switch formControlName="isActive" [onLabel]="'Yes'" [offLabel]="'No'"
                          class="activeSwitchCls">
            </kendo-switch>
          </div>


        </div>

      </div>

      <div class="dialog-btn-section">
        <div class="row">
          <div class="col-sm-12 float-left">
            <app-info *ngIf="infoMessage" [infoMessage]="infoMessage"></app-info>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12 btn-align-center">
            <div class="btn-group" role="group">
              <button kendoButton [disabled]="saveInProcess" class=" m-3 btn k-button dialogBtnSize"
                      (click)="toggleSurveyDialog()">
                {{survey.closeLbl}}
              </button> &nbsp;&nbsp;
              <button kendoButton [disabled]="saveInProcess" class=" m-3 btn btn-success dialogBtnSize"
                      (click)="saveSurveyDetails()">
                {{survey.saveLbl}}<kendo-loader *ngIf="saveInProcess" style="color:blue"></kendo-loader>
              </button>
            </div>
          </div>
        </div>
      </div>
    </form>
  </kendo-dialog>
</section>

<kendo-dialog title="{{gridDelete.label.confirmLbl?gridDelete.label.confirmLbl:gridDelete.label.confirmLbl}}" *ngIf="gridItemToRemove" (close)="confirmRemove(false)">
  <p style="margin: 30px; text-align: center;">
    {{gridDelete.label.deleteConfirmLbl?gridDelete.label.deleteConfirmLbl:gridDelete.label.deleteConfirmLbl}}
    <b> : {{ gridItemToRemove.questions }}</b>?
  </p>
  <kendo-dialog-actions>
    <button class='k-button' (click)="confirmRemove(false)">
      {{gridDelete.label.deleteNoLbl?gridDelete.label.deleteNoLbl:gridDelete.label.deleteNoLbl}}
    </button>
    <button class='k-button k-primary' (click)="confirmRemove(true)" primary="true">
      {{gridDelete.label.deleteYesLbl?gridDelete.label.deleteYesLbl:gridDelete.label.deleteYesLbl}}
    </button>
  </kendo-dialog-actions>
</kendo-dialog>
